export const getQueryParam = (term: string) => {
  return (
    window.location.search
      .replace("?", "")
      .split("&")
      .find((item) => item.includes(`${term}=`))
      ?.replace(`${term}=`, "") ?? ""
  );
};
